<div *ngIf="isLoading" class="flex items-center justify-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>

<div *ngIf="!isLoading" class="container px-4 py-7">
  <div class="w-full form-container">
    <div class="w-full p-6 bg-white rounded-md shadow-lg">
      <h2 class="mb-4 text-2xl font-bold">Edit Invoice</h2>
      <form [formGroup]="invoiceForm" (ngSubmit)="onSubmit()" class="w-full p-4">
        <div class="flex items-center mb-4 form-group">
          <label for="invoice_number" class="w-1/12 text-sm font-medium text-gray-700">Invoice Number:</label>
          <input pInputText id="invoice_number" formControlName="invoice_number" class="block w-11/12 mt-1" />
          <small *ngIf="invoiceForm.get('invoice_number')?.invalid && invoiceForm.get('invoice_number')?.touched"
            class="text-red-500">Invoice Number is required</small>
        </div>

        <div class="flex items-center mb-4 form-group">
          <label for="customer" class="w-1/12 text-sm font-medium text-gray-700">Customer:</label>
          <p-dropdown formControlName="customer" [options]="customers" placeholder="Select a Customer"
            optionLabel="name" [filter]="true" filterBy="name" />
          <small *ngIf="invoiceForm.get('customer')?.invalid && invoiceForm.get('customer')?.touched"
            class="text-red-500">Customer is required</small>
        </div>

        <div class="flex items-center mb-4 form-group">
          <label for="due_date" class="w-1/12 text-sm font-medium text-gray-700">Due Date:</label>
          <p-datepicker formControlName="due_date" [showIcon]="true" class="block w-11/12 mt-1" />
          <small *ngIf="invoiceForm.get('due_date')?.invalid && invoiceForm.get('due_date')?.touched"
            class="text-red-500">Due Data is required</small>
        </div>

        <div class="flex gap-2">
          <p-button *ngIf="!inEditMode" icon="pi pi-plus" label="Add New Line" severity="primary" class=" 
          hover:!text-blue-600 transition-all duration-300" (onClick)="addNewLine()"></p-button>
        </div>

        <div class="w-full overflow-x-auto h-[300px] overflow-y-auto border border-gray-300 shadow-md">
          <p-table stripedRows showGridlines responsiveLayout="scroll" [rowHover]="true" [autoLayout]="true"
            [value]="lines" class="w-full max-w-[800px] h-[300px] border-gray-300 shadow-md" dataKey="id" editMode="row"
            [editingRowKeys]="editingRowKeys" #invoiceLines formArrayName="rows">
            <ng-template pTemplate="header">
              <tr class="text-gray-700 bg-gray-100">
                <th class="p-3 border-b w-13">Type</th>
                <!-- <th style="width:8%">Subscription</th> -->
                <th class="p-3 border-b w-13">Period Start</th>
                <th class="p-3 border-b w-13">Period End</th>
                <th class="p-3 border-b w-13">Description</th>
                <th class="p-3 border-b w-13">Taxable</th>
                <th class="p-3 border-b w-13">Unit Price</th>
                <th class="p-3 border-b w-13">Quantity</th>
                <th class="p-3 border-b w-13">Discount Type</th>
                <th class="p-3 border-b w-13">Discount</th>
                <th class="p-3 border-b w-13">Discount Total</th>
                <th class="p-3 border-b w-13">Total Price</th>
                <th class="p-3 border-b w-13"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-line let-editing="editing" let-i="rowIndex">
              <tr class="border-b hover:bg-gray-50" [formGroupName]="i" [pEditableRow]="line">
                <td class="relative p-3 w-13">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-dropdown required [options]="lineTypes" formControlName="line_type" class="form-control"
                        class="z-50 w-full" appendTo="body" placeholder="Select a line type" />
                    </ng-template>
                    <ng-template pTemplate="output">{{line.line_type}}</ng-template>
                  </p-cellEditor>
                </td>
                <!-- <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown formControlName="subscription" required [options]="subscriptions"
                      placeholder="Select a Subscription" optionLabel="name" />
                  </ng-template>
                  <ng-template pTemplate="output">{{line.subscription}}</ng-template>
                </p-cellEditor>
              </td> -->
                <td class="relative p-3 w-13">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-datepicker [showIcon]="true" formControlName="period_start"
                        class="z-50 w-full p-2 text-center border border-gray-300 rounded-md" appendTo="body" />
                    </ng-template>
                    <ng-template pTemplate="output">{{line.period_start | date}}</ng-template>
                  </p-cellEditor>
                </td>
                <td class="relative p-3 w-13">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-datepicker [showIcon]="true" formControlName="period_end"
                        class="z-50 w-full p-2 text-center border border-gray-300 rounded-md" appendTo="body" />
                    </ng-template>
                    <ng-template pTemplate="output">{{line.period_end | date}}</ng-template>
                  </p-cellEditor>
                </td>
                <td class="p-3 w-13">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input pInputText type="text" formControlName="description"
                        class="w-full p-2 text-center border border-gray-300 rounded-md" />
                    </ng-template>
                    <ng-template pTemplate="output">{{line.description}}</ng-template>
                  </p-cellEditor>
                </td>
                <td class="p-3 text-center w-13">
                  <p-tableCheckbox [value]="line.taxable" [disabled]="!editing"
                    class="mr-2 shadow-md  shaow-gray-800" />
                </td>
                <td class="p-3 w-13">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-inputNumber formControlName="unit_price" required mode="decimal" [minFractionDigits]="2"
                        [maxFractionDigits]="3" class="w-full p-2 text-center border border-gray-300 rounded-md" />
                    </ng-template>
                    <ng-template pTemplate="output">{{line.unit_price}}</ng-template>
                  </p-cellEditor>
                </td>
                <td class="p-3 w-13">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-inputNumber formControlName="quantity" required mode="decimal" [minFractionDigits]="0"
                        [maxFractionDigits]="2" class="w-full p-2 text-center border border-gray-300 rounded-md" />
                    </ng-template>
                    <ng-template pTemplate="output">{{line.quantity}}</ng-template>
                  </p-cellEditor>
                </td>
                <td class="p-3 w-13">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input pInputText type="text" formControlName="discount_type"
                        class="w-full p-2 text-center border border-gray-300 rounded-md" />
                    </ng-template>
                    <ng-template pTemplate="output">{{line.discount_type}}</ng-template>
                  </p-cellEditor>
                </td>
                <td class="p-3 w-13">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-inputNumber formControlName="discount_type_value" mode="decimal" [minFractionDigits]="0"
                        [maxFractionDigits]="2" class="w-full p-2 text-center border border-gray-300 rounded-md" />
                    </ng-template>
                    <ng-template pTemplate="output">{{line.discount_type_value}}</ng-template>
                  </p-cellEditor>
                </td>
                <td class="w-32 min-w-0 p-3">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-inputNumber formControlName="discount_total" mode="decimal" [minFractionDigits]="0"
                        [maxFractionDigits]="2" class="w-full p-2 text-center border border-gray-300 rounded-md" />
                    </ng-template>
                    <ng-template pTemplate="output"
                      class="block w-full p-2 text-center">{{line.discount_total}}</ng-template>
                  </p-cellEditor>
                </td>
                <td class="p-3 w-13">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-inputNumber formControlName="line_total" mode="decimal" [minFractionDigits]="0"
                        [maxFractionDigits]="2" class="w-full p-2 text-center border border-gray-300 rounded-md" />
                    </ng-template>
                    <ng-template pTemplate="output">{{line.line_total}}</ng-template>
                  </p-cellEditor>
                </td>
                <td class="p-3 w-13">
                  <div class="flex gap-2 align-items-center justify-content-center">
                    <button *ngIf="!inEditMode && !isEditing(line, i)" pButton pRipple type="button" pInitEditableRow
                      icon="pi pi-pencil" (click)="onRowEditInit(line, i)" class="p-button-rounded p-button-text">
                    </button>
                    <button *ngIf="inEditMode && isEditing(line, i)" pButton pRipple type="button" pSaveEditableRow
                      icon="pi pi-check" (click)="onRowEditSave(line, i)"
                      class="mr-2 p-button-rounded p-button-text p-button-success">
                    </button>
                    <button *ngIf="inEditMode && isEditing(line, i)" pButton pRipple type="button" pCancelEditableRow
                      icon="pi pi-times" (click)="onRowEditCancel(line, i)"
                      class="p-button-rounded p-button-text p-button-danger">
                    </button>
                    <button *ngIf="!inEditMode && !isEditing(line, i)" (click)="deleteRow(i)" type="button" pRipple
                      pButton icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="flex items-center pt-2 mb-4 form-group">
          <label for="excluding_tax" class="w-1/12 text-sm font-medium text-gray-700">Amount:</label>
          <input pInputText id="excluding_tax" formControlName="excluding_tax" class="block w-11/12 mt-1" />
          <small *ngIf="invoiceForm.get('excluding_tax')?.invalid && invoiceForm.get('excluding_tax')?.touched"
            class="text-red-500">Amount is required</small>
        </div>
        <div class="flex items-center mb-4 form-group">
          <label for="discount_value" class="w-1/12 text-sm font-medium text-gray-700">Discount:</label>
          <input pInputText id="discount_value" formControlName="discount_value" class="block w-11/12 mt-1" />
        </div>
        <div class="flex items-center mb-4 form-group">
          <label for="tax" class="w-1/12 text-sm font-medium text-gray-700">Tax:</label>
          <input pInputText id="tax" formControlName="tax" class="block w-11/12 mt-1" />
          <small *ngIf="invoiceForm.get('tax')?.invalid && invoiceForm.get('tax')?.touched" class="text-red-500">Tax is
            required</small>
        </div>
        <div class="flex items-center mb-4 form-group">
          <label for="including_tax" class="w-1/12 text-sm font-medium text-gray-700">Total:</label>
          <input pInputText id="including_tax" formControlName="including_tax" class="block w-11/12 mt-1" />
          <small *ngIf="invoiceForm.get('including_tax')?.invalid && invoiceForm.get('including_tax')?.touched"
            class="text-red-500">Total is required</small>
        </div>

        <div class="flex items-center mb-4 form-group">
          <label for="status" class="w-1/12 text-sm font-medium text-gray-700">Status:</label>
          <p-dropdown formControlName="status" [options]="statuses" placeholder="Select a Status" />
          <small *ngIf="invoiceForm.get('status')?.invalid && invoiceForm.get('status')?.touched"
            class="text-red-500">Status is required</small>
        </div>

        <div class="flex items-center pt-2 mb-4 space-x-8 form-group">
          <div class="flex items-center">
            <p-checkbox formControlName="sent" value="Invoice Sent" inputId="sent"
              class="mr-2 shadow-md shadow-gray-800" />
            <label for="sent" class="font-medium text-gray-700 text-md">Invoice Sent</label>
          </div>

          <div class="flex items-center">
            <p-checkbox formControlName="is_deleted" value="Invoice Deleted" inputId="is_deleted"
              class="mr-2 shadow-md shadow-gray-800" />
            <label for="is_deleted" class="font-medium text-gray-700 text-md">Invoice Deleted</label>
          </div>

          <div class="flex items-center">
            <a *ngIf="url && url.value !== ''" [href]="url!.value" type="button"
              class="flex items-center text-blue-500 hover:text-blue-600">
              <span class="mr-2 p-button-icon pi pi-download"></span>
              Download Invoice
            </a>
            <span *ngIf="!url">Invoice not generated yet</span>
          </div>


        </div>

        <div class="flex justify-start py-4">
          <button pButton type="submit" [disabled]="invoiceForm.invalid" class="rounded-md primary-btn">Save</button>
        </div>
        <div class="flex items-center">
          <button pButton label="Back to List" icon="pi pi-arrow-left" class="p-button-secondary" type="button"
            routerLink="/invoices/list"></button>
        </div>
      </form>
    </div>
  </div>
</div>